import React from 'react';
import { Box, RoundCloseIcon, Text } from '@common-fe/common-fe';

export const testId = 'EnrollmentConflictBanner';

interface Props {
  message?: string;
}

const DEFAULT_MESSAGE = "You're already enrolled in a plan for this date";

const EnrollmentConflictBanner: React.FC<Props> = ({ message = DEFAULT_MESSAGE }) => (
  <Box
    data-testid={`${testId}-wrapper`}
    pad={{ horizontal: 'spacing24', vertical: 'spacing16' }}
    border={{ color: 'dangerBorder', size: 'small' }}
    background="dangerContainer"
    round="container2Round"
    direction="row"
    align="center"
  >
    <RoundCloseIcon color="danger" size="24px" />
    <Text
      weight={700}
      color="textBody"
      margin={{ left: 'spacing8' }}
      style={{ lineHeight: '20px' }}
      data-testid={`${testId}-message`}
    >
      {message}
    </Text>
  </Box>
);

export default EnrollmentConflictBanner;
